import {
  DocumentsDocument,
  SendInBulkUpdateDocument,
  SendInBulkUpdateMutation,
  SendInBulkUpdateMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useSendInBulkUpdate = () => {
  const [mutate, { loading }] = useMutation(SendInBulkUpdateDocument, {
    extractorFn: (data: SendInBulkUpdateMutation) =>
      data.documentsMutations.sendInBulkUpdateDocumentsDocument,
  })

  const submit = (variables: SendInBulkUpdateMutationVariables) => {
    return mutate({
      variables,
      awaitRefetchQueries: true,
      refetchQueries: [DocumentsDocument],
    })
  }

  return { submit, loading }
}
